import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.sort.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from 'vuex'
import depTree from '@/components/dep-tree';
import staffSearch from '_c/staff-search';
import holidayDialog from './holiday-dialog';
import { restListFn } from 'api/approval/config';
import uploadDialog from './uploadDialog';
export default {
  components: {
    depTree: depTree,
    staffSearch: staffSearch,
    holidayDialog: holidayDialog,
    uploadDialog: uploadDialog
  },
  data: function data() {
    return {
      popover: false,
      dataForm: {},
      pageSizes: [100, 50, 20],
      page: {
        list: [],
        currPage: 1,
        limit: 100,
        total: 0
      },
      sort: '',
      dir: '',
      holidayArr: [],
      isHolidayDialog: false
    };
  },
  mounted: function mounted() {
    this.getTableList();
  },
  methods: {
    // 排序
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.sort = prop;
      this.dir = order;
      this.getTableList();
    },
    handleNodeClick: function handleNodeClick(val) {
      this.dataForm = Object.assign(this.dataForm, val);
      this.popover = false;
    },
    staffChange: function staffChange(val) {
      this.dataForm = Object.assign(this.dataForm, val);
    },
    modifyHoliday: function modifyHoliday() {
      this.$refs.uploadDialog.init();
    },
    getTableList: function getTableList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return restListFn(_objectSpread({
                page: _this.page.currPage,
                size: _this.page.limit,
                sort: _this.sort,
                // 排序相关
                dir: _this.dir
              }, _this.dataForm));
            case 2:
              res = _context.sent;
              _this.$emit('clear-loading');
              if (res && res.code === 1 && res.data) {
                _this.page.total = res.data.count;
                _this.holidayArr = res.data.type_list;
                _this.page.list = res.data.leave_list;
                _this.$nextTick(function () {
                  return _this.$refs.table.doLayout && _this.$refs.table.doLayout();
                });
              } else {
                _this.page.total = 0;
                _this.holidayArr = [];
                _this.page.list = [];
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 每页条数
    sizeChangeHandle: function sizeChangeHandle(val) {
      this.page.limit = val;
      this.getTableList();
    },
    // 切换 页
    currentChangeHandle: function currentChangeHandle(val) {
      this.page.currPage = val;
      this.getTableList();
    },
    holidayHandle: function holidayHandle(item, row) {
      var _this2 = this;
      if (this.$p('menu.work.rule.edit')) {
        this.isHolidayDialog = true;
        this.$nextTick(function () {
          return _this2.$refs.holidayDialog.init(item, row);
        });
      }
    },
    departmentClear: function departmentClear() {
      this.dataForm.department_id = null;
    }
  }
};